import type { ProviderInfo } from '../types/foundObject';

export type PlaceStorageMode = 'combined' | 'split' | 'central';

export function resolvePlaceStorageMode(
  providerInfo?: Pick<ProviderInfo, 'place_storage_mode' | 'provider_type'> | null
): PlaceStorageMode {
  const mode = providerInfo?.place_storage_mode ?? providerInfo?.provider_type?.place_storage_mode;
  if (mode === 'split' || mode === 'central') {
    return mode;
  }
  return 'combined';
}

export function isSplitPlaceStorageMode(
  providerInfo?: Pick<ProviderInfo, 'place_storage_mode' | 'provider_type'> | null
): boolean {
  return resolvePlaceStorageMode(providerInfo) === 'split';
}

export function isCentralPlaceStorageMode(
  providerInfo?: Pick<ProviderInfo, 'place_storage_mode' | 'provider_type'> | null
): boolean {
  return resolvePlaceStorageMode(providerInfo) === 'central';
}

/** Boîtes rattachées au prestataire (sans lieu festival). */
export function usesCentralStorageBoxes(
  providerInfo?: Pick<ProviderInfo, 'place_storage_mode' | 'provider_type'> | null
): boolean {
  const mode = resolvePlaceStorageMode(providerInfo);
  return mode === 'split' || mode === 'central';
}
